import { data } from '../../svg/Link/data';
import { makeIcon } from '../makeIcon';

export const Link = makeIcon(data, 'link', 'Link');

export default Link;
